/* eslint-disable default-case */
import produce from 'immer';

import {
  types,
  Venue,
  VenuesState,
  VenuesActionTypes,
  CreateVenuePayload,
  GetVenuesPending,
  GetVenuesSuccess,
  GetVenuesError,
  CreateVenuePending,
  CreateVenueError,
  UpdateVenuePayload,
  UpdateVenuePending,
  UpdateVenueSuccess,
  UpdateVenueError,
  DeleteVenuePending,
  DeleteVenueError
} from './types';

// Actions
export const actions = {
  getVenues: (): VenuesActionTypes => ({ type: types.GET_VENUES.REQUEST }),
  createVenue: (payload: CreateVenuePayload): VenuesActionTypes => ({
    type: types.CREATE_VENUE.REQUEST,
    payload
  }),
  updateVenue: (payload: UpdateVenuePayload) => ({
    type: types.UPDATE_VENUE.REQUEST,
    payload
  }),
  deleteVenue: (payload: { id: string }): VenuesActionTypes => ({
    type: types.DELETE_VENUE.REQUEST,
    payload
  }),
  resetAction: () => ({ type: types.RESET_ACTION }),
  resetError: () => ({ type: types.RESET_ERROR })
};

// Initial State
export const initialState: VenuesState = {
  venues: [],
  action: {
    success: false,
    pending: false,
    error: null
  }
};

// Reducer
export const reducer = (state: VenuesState = initialState, action: VenuesActionTypes): VenuesState => {
  return produce(state, (draft) => {
    switch (action.type) {
      case types.GET_VENUES.PENDING:
      case types.CREATE_VENUE.PENDING:
      case types.UPDATE_VENUE.PENDING:
      case types.DELETE_VENUE.PENDING:
        draft.action.pending = (
          action as GetVenuesPending | CreateVenuePending | UpdateVenuePending | DeleteVenuePending
        ).payload;
        break;
      case types.GET_VENUES.SUCCESS:
        draft.venues = (action as GetVenuesSuccess).payload;
        break;
      case types.CREATE_VENUE.SUCCESS:
      case types.DELETE_VENUE.SUCCESS:
        draft.action.success = true;
        break;
      case types.UPDATE_VENUE.SUCCESS:
        const payload = (action as UpdateVenueSuccess).payload;
        if (draft.venues.length) {
          const venueIndex = draft.venues.findIndex((v) => v.id === (payload as Venue).id);
          if (venueIndex > -1) {
            Object.assign(draft.venues[venueIndex], payload);
          }
        }
        break;
      case types.GET_VENUES.ERROR:
      case types.UPDATE_VENUE.ERROR:
      case types.CREATE_VENUE.ERROR:
      case types.DELETE_VENUE.ERROR:
        draft.action.error = (
          action as GetVenuesError | CreateVenueError | UpdateVenueError | DeleteVenueError
        ).payload;
        break;
      case types.RESET_ERROR:
        draft.action.error = initialState.action.error;
        break;
      case types.RESET_ACTION:
        draft.action = initialState.action;
        break;
    }
  });
};
